module.exports = __webpack_public_path__ + "img/down.fffac89.png";